var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanpath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.344,
    height: 15.099,
    viewBox: "0 0 14.344 15.099",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M385.944,742.37l-6.04-1.887v4.152l1.51,1.132V746.9l-2.642-.755-2.642.755v-1.132l1.51-1.132v-4.152l-6.04,1.887v-1.51l6.04-3.775v-4.152a1.135,1.135,0,0,1,.3-.83,1.134,1.134,0,0,1,1.963.83v4.152l6.04,3.775Z",
    transform: "translate(-371.6 -731.8)",
    fill: "#fd5634"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanpath);
export default __webpack_public_path__ + "static/media/planpath.3861fd0abad13fcd7c6721231a9c4850.svg";
export { ForwardRef as ReactComponent };